import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import NavigationData from "../../../layout/Sidebar/NavigationData";
import { getItemToken } from "../../../Utils/localStorageUtils";
import AdminSaveHeader from "../../../components/CommonComponents/AdminSaveHeader";
import FormContainer from "../../../components/CommonComponents/FormContainer";
import Wrapper from "../../../components/CommonComponents/Wrapper";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import { toast } from "react-toastify";
import LeftWrapper from "../../../components/CommonComponents/LeftWrapper";
import MessageBox from "../../../components/CommonComponents/MessageBox";
import RightWrapper from "../../../components/CommonComponents/RightWrapper";
import AdminSwitch from "../../../components/CommonComponents/AdminSwitch";
import AdminImageUploadZone from "../../../components/CommonComponents/AdminImageUploadZone";
import AdminCustomButton from "../../../components/CommonComponents/AdminCustomButton";
import AdminCustomInput from "../../../components/CommonComponents/AdminCustomInput";
import AdminCustomSelect from "../../../components/CommonComponents/AdminCustomSelect";
import { slugGenerator } from "../../../components/CommonMethod/CommonMethods";
import AdminBackNavigation from "../../../components/CommonComponents/AdminBackNavigation";
import useCompressImageConfig from "../../../components/CommonApis/Compressimageapi";
import FieldRenderer from "../../../CustomFields/FieldRenderer";
import FieldRenderer2 from "../../../CustomFields/FieldRenderer2";
import saveCustomFieldsStrict from "../../../CustomFields/saveCustomFieldsStrict";
import { useMyContext } from "../../../components/Provider/CommonProvider";
function AddManagevideocategories({ forceCreate = false, onSuccess, isModal = false }) {
  const headers = getItemToken('access_token')
  const { id } = useParams()
  const combinedRef = useRef([]);
  const navigate = useNavigate();
  const { compressResolutionFormat } = useCompressImageConfig();

  const baseURL = process.env.REACT_APP_Baseurl
  const createApi = `${baseURL}/admin/videos-category/create`
  const editApi = `${baseURL}/admin/videos-category/edit/${id}`

  const [customFieldValues, setCustomFieldValues] = useState({});
  const { fetchRequest, globalImageUplaodAPI } = useMyContext();
  const [formData, setFormData] = useState({
    name: '',
    slug: '',
    parent_id: '',
    home_genre: '',
    in_home: 0,
    in_menu: 0,
    footer: 0,
    banner: 0,
    parent_category: true
  })

  const [formDataError, setFormDataError] = useState({})
  const [coverImageFile, setCoverImageFile] = useState(null);
  const [bannerImageFile, setBannerImageFile] = useState(null);
  const [showOverlay, setShowOverlay] = useState(false);
  const [withOutRefresh, setWithOutRefresh] = useState(false)

  const { label_management } = NavigationData();
  const [labelDisplay, setLabelDisplay] = useState([]);


  const setRef = (element, index) => {
    if (element) {
      combinedRef.current[index] = element;
    }
  };

  const validateImageRatio = (file, expectedRatio, expectedWidth, expectedHeight) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = URL.createObjectURL(file);
      img.onload = () => {
        const width = img.width;
        const height = img.height;
        const ratio = width / height;
        const expectedRatioPrecision = 0.01;
        const ratioMatch = Math.abs(ratio - expectedRatio) < expectedRatioPrecision;
        const dimensionMatch = (width === expectedWidth && height === expectedHeight);
        if (ratioMatch || dimensionMatch) {
          resolve(true);
        } else {
          resolve(false);
        }
      };
      img.onerror = () => {
        // reject(new Error('Error loading image'));
        toast.error('Error loading image');
      };
    });
  };

  const handleFileChange = async (event) => {
    const { files, name, value, accept } = event.target
    const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/webp'];
    const checkSize = compressResolutionFormat?.videos === 1
    setFormDataError((prev) => ({
      ...prev,
      [name]: "",
    }));

    if (files?.length > 0) {
      const newFile = files[0];
      const reader = new FileReader();
      const readFile = (file) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
          reader.readAsDataURL(file);
        });
      };
      const fileContent = await readFile(newFile);

      if (!allowedTypes.includes(files[0]?.type)) {
        setFormDataError((prev) => ({
          ...prev,
          [name]: "Only JPG, JPEG, and PNG files are allowed.",
        }));
        setCoverImageFile(null);
        setBannerImageFile(null);
        combinedRef.current['image'].focus()
        return;
      }

      if (name == 'image') {
        setCoverImageFile(newFile);
        if (checkSize) {
          const isValidSize = await validateImageRatio(newFile, 1 / 1, 1080, 1080);

          if (!isValidSize) {
            console.log(isValidSize, "Image must be in 1:1 Ratio or 1080x1080px.")
            setFormDataError((prev) => ({
              ...prev,
              [name]: "Image must be in 1:1 Ratio or 1080x1080px.",
            }));
          }
        }


      }
      if (name == 'banner_image') {
        setBannerImageFile(newFile);
        const isValidSize = await validateImageRatio(newFile, 16 / 9, 1280, 720);

        if (!isValidSize) {
          setFormDataError((prev) => ({
            ...prev,
            [name]: "Image must be in 16:9 Ratio or 1280x720px.",
          }));
        }
      }
    }
  };

  const handleCoverImageChange = (event) => {
    const selectedFile = event.target.files;
    if (selectedFile?.length > 0) {
      const newFile = selectedFile[0];
      const reader = new FileReader();
      reader.onload = () => {
        setCoverImageFile(newFile);
      };
      reader.readAsDataURL(newFile);
    } else {
    }
  };
  const handleBannerImageChange = (event) => {
    const selectedFile = event.target.files;
    if (selectedFile?.length > 0) {
      const newFile = selectedFile[0];
      const reader = new FileReader();
      reader.onload = () => {
        setBannerImageFile(newFile);
      };
      reader.readAsDataURL(newFile);
    } else {
    }
  };


  const handleAdd = async () => {
    setShowOverlay(true);
    try {
      const formDataAdd = {};
      for (const key in formData) {
        if (["name", "slug", "parent_id", "home_genre", "in_home", "in_menu", "footer", "banner"].includes(key)) {
          formDataAdd[key] = formData[key]
        }
      }
      const response = await axios.post(`${process.env.REACT_APP_Baseurl}/admin/videos-category/store`, formDataAdd, { headers: headers });
      const result = response?.data;
      if (result?.status) {
        // save custom field values (strict)
        try {
          await saveCustomFieldsStrict({ baseURL, headers, entityType: 'video_category', entityId: result?.id, values: customFieldValues });
        } catch (e) {
          toast.error(e.message || 'Failed to save additional fields');
          setShowOverlay(false);
          return;
        }
        if (coverImageFile || bannerImageFile) {
          await handleImageUpload(result?.id)
        }
        setShowOverlay(false);
        toast.success(result?.message)
        if (typeof onSuccess === 'function') {
          onSuccess(result?.id, formData?.name);
        } else {
          navigate("/video-categories");
        }
      }
      else {
        setShowOverlay(false);
        toast.error(result?.message)
      }
    }
    catch (err) {
      setShowOverlay(false);
      const errorMessage = err?.response?.data?.message
      toast.error(errorMessage)
      console.error("error", err)
    }
  }


  const handleImageUpload = async (id) => {
    try {
      const formDataAdd = new FormData();
      const modelName = "VideoCategory";
      formDataAdd.append('image', coverImageFile)
      formDataAdd.append('banner_image', bannerImageFile)
      formDataAdd.append('category_id', id)
      formDataAdd.append('id', id)
      formDataAdd.append('modelName', modelName)
      formDataAdd.append('imageFields[]', 'image')
      formDataAdd.append('imageFields[]', 'banner_image')
      const response = await fetchRequest({ method: 'POST', url: globalImageUplaodAPI(), params: {}, data: formDataAdd, });
      if (!response?.data?.status) {
        toast.success(response?.data?.message)
      }
      if (response?.data?.status) {
        setCoverImageFile(null)
        setBannerImageFile(null)
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err?.message)
    }
  }


  const handleInput = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox") {
      setFormData((prev) => ({
        ...prev,
        [name]: checked ? 1 : 0,
      }));
    }
    else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
      setFormDataError((prev) => ({
        ...prev,
        [name]: '',
      }));
    }
  };

  const handleInputKeyDowntitle = (event) => {
    if (event.key === "Enter" || event.key === "Tab") {
      if (formData?.slug) {
        return
      }
      generateSlug(formData?.name);
    }
  };
  const handleBlurtitle = () => {
    if (formData?.slug) {
      return
    }
    generateSlug(formData?.name);
  };

  const generateSlug = async (name) => {
    const slug = await slugGenerator(name)
    setFormData((prev) => ({
      ...prev,
      'slug': slug,
    }));
  };

  const fetchData = async () => {
    try {
      setShowOverlay(true)
      const response = await fetchRequest({ method: 'GET', url: id ? editApi : createApi })

      if (response?.status) {
        setFormData(response?.data)
        toast.success(response?.message)
      }
    } catch (error) {
      toast.error(error.response.message)
    } finally {
      setShowOverlay(false)
    }
  }



  const handleBlurTitleEdit = () => {
    generateSlug(formData?.slug);
  };


  const formValidation = () => {
    let formIsValid = true;
    if (!formData?.name || formData?.name.trim().length < 3 || formData?.name.trim().length > 100) {
      toast.error("Name must be between 3 and 100 characters.");
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        name: "Name must be between 3 and 100 characters.",
      }));
      combinedRef.current['name'].focus()
      formIsValid = false;
    }

    if (!formData?.slug || formData?.slug.trim().length < 3 || formData?.slug.trim().length > 100) {
      toast.error("Slug must be between 3 and 100 characters.");
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        slug: "Slug must be between 3 and 100 characters.",
      }));
      combinedRef.current['slug'].focus()
      formIsValid = false;
    }
    return formIsValid;
  }

  const handleStore = () => {
    const creating = forceCreate || !id;
    if (creating) {
      if (formValidation()) {
        handleAdd()
      } else {
        console.log("validation")
      }
    } else {
      handleUpdate()
    }
  }

  const handleUpdate = async () => {
    setShowOverlay(true);
    try {
      const formDataAdd = {};
      for (const key in formData) {
        if (["name", "slug", "parent_id", "home_genre", "in_home", "in_menu", "footer", "banner"].includes(key)) {
          formDataAdd[key] = formData[key]
        }
      }

      if (formData?.parent_category === 1) {
        formDataAdd.parent_id = null
      }
      const response = await axios.post(`${process.env.REACT_APP_Baseurl}/admin/videos-category/update/${id}`, formDataAdd, { headers: headers });
      const result = response?.data;
      if (result?.status) {
        // save custom field values (strict)
        try {
          await saveCustomFieldsStrict({ baseURL, headers, entityType: 'video_category', entityId: id, values: customFieldValues });
        } catch (e) {
          toast.error(e.message || 'Failed to save additional fields');
          setShowOverlay(false);
          return;
        }
        if (coverImageFile || bannerImageFile) {
          await handleImageUpload(result?.videoCategory?.id)
        }
        setShowOverlay(false);
        toast.success(result?.message)
        setWithOutRefresh(!withOutRefresh)
      }
      else {
        setShowOverlay(false);
        toast.error(result?.message)
      }
    }
    catch (err) {
      setShowOverlay(false);
      const errorMessage = err?.response?.data?.message
      toast.error(errorMessage)
      console.error("error", err)
    }
  }

  const handleClearSelectFile = (value) => {
    if (value == 'image') {
      setCoverImageFile(null)
    }
    else {
      setBannerImageFile(null)
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  useEffect(async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_Baseurl}/admin/Label-Management/list-source`,
        {
          headers: headers,
          params: { source: "add-videocategory" },
        }
      );
      setLabelDisplay(response?.data?.label_management || []);
    } catch (error) {
      console.error("Error fetching label display:", error);
    }
  }, []);

  function flattenCategories(list, level = 0, result = []) {
    list.forEach(item => {
      const indent = '\u00A0\u00A0\u00A0\u00A0'.repeat(level); // padding
      const prefix = level ? '• ' : '';

      result.push({
        id: item.id,
        label: `${indent}${prefix}${item.name}`, // for dropdown list
        name: item.name                           // clean name
      });

      if (item.sub_category?.length) {
        flattenCategories(item.sub_category, level + 1, result);
      }
    });
    console.log(`result ${JSON.stringify(result)}`);
    
    return result;
  }
  console.log(`formData?.allCategory ${JSON.stringify(formData?.allCategory)}`);
  
  const flatOptions = flattenCategories(formData?.allCategory || []);


  return (
    <div className="pb-5">
      {showOverlay && (<Response_Processing></Response_Processing>)}
      {!isModal && <AdminBackNavigation path={`${"/video-categories"}`} text="Back" />}
      {!isModal && <AdminSaveHeader buttonId="video-category-submit-up" heading={!id ? labelDisplay?.[0]?.title : labelDisplay?.[14]?.title} saveText={!id ? labelDisplay?.[13]?.title : labelDisplay?.[13]?.title} saveMethod={handleStore} />}
      <FormContainer>
        <LeftWrapper>
          <Wrapper>
            <MessageHeading text={!id ? labelDisplay?.[1]?.title : formData?.name} />
            <MessageLabel text={labelDisplay?.[2]?.title} className="mandatorySimple" />
            <AdminCustomInput id="video-category-name" type="text" name="name" value={formData?.name} onChange={handleInput} placeHolder={"Title"} ref={(el) => (combinedRef.current.name = el)} onBlur={handleBlurtitle} onKeyDown={handleInputKeyDowntitle} error={formDataError?.name} />
            <MessageLabel text={labelDisplay?.[3]?.title} className="mandatorySimple" />
            <AdminCustomInput id="video-category-slug" type="text" name="slug" value={formData?.slug} ref={(el) => (combinedRef.current.slug = el)} onChange={handleInput} onBlur={() => handleBlurTitleEdit()} placeHolder={"Slug"} error={formDataError?.slug} />
            <MessageLabel text={labelDisplay?.[4]?.title} />
            <AdminCustomInput id="video-category-home-genre" type="text" name="home_genre" value={formData?.home_genre} ref={(el) => (combinedRef.current.home_genre = el)} onChange={handleInput} placeHolder={"Home genre"} error={formDataError?.home_genre} />
            <FormContainer>
              <div className="col-7 col-md-7 pe-2">
                <MessageLabel text={"Make as Parent Category"} />
              </div>
              <div className="col-5 col-md-5 ps-2 text-end">
                <AdminSwitch id="retain-value" name="parent_category" checked={Number(formData?.parent_category) === 1} onChange={handleInput} />
              </div>
            </FormContainer>
            {formData?.parent_category === 0 && <>
              <MessageLabel text={labelDisplay?.[5]?.title} />

              <select
                name="parent_id"
                value={formData?.parent_id || ""}
                onChange={handleInput}
                className="custom-input custom-input-border w-100 custom-placeholder bg-transparent theme-text-color"
              >
                <option value="">Choose a category</option>
                {flatOptions.map(opt => (
                  <option className="theme-bg-color theme-text-color" key={opt.id} value={opt.id}>{opt.label}</option>
                ))}
              </select>



              {formDataError?.parent_id && (
                <p className="text-danger">{formDataError.parent_id}</p>
              )}
              {/* <AdminCustomSelect id="video-category-parent-id" name="parent_id" value={formData?.parent_id} onChange={handleInput} ref={(el) => (combinedRef.current.parent_id = el)} options={formData?.allCategory} error={formDataError?.parent_id} defaultOptionName={"Choose an category"} /> */}
            </>}
            <div className="card p-3 mt-3">
              {/* Custom fields */}
              <FieldRenderer2
                pageIdentifier={id ? "video_category.edit" : "video_category.create"}
                entityType="video_category"
                entityId={id}
                text="Additional Fields"
              />
              <FieldRenderer
                pageIdentifier={id ? "video_category.edit" : "video_category.create"}
                entityType="video_category"
                entityId={id}
                onChange={setCustomFieldValues}
              />
            </div>
          </Wrapper>
        </LeftWrapper>

        <RightWrapper>
          <Wrapper>
            <MessageHeading text={labelDisplay?.[10]?.title} />
            <MessageLabel text={labelDisplay?.[11]?.title} className="" />
            <p className="mb-3 mt-0 theme-text-color opacity-75 admin-input-description">Select the image( 1:1 Ratio or 1080x1080px )</p>
            <AdminImageUploadZone
              onChange={handleFileChange}
              selectedFile={coverImageFile}
              uploadedImage={formData?.image}
              onDelete={handleClearSelectFile}
              fileInputRef={setRef}
              name="image"
              id={id}
              idAttribute="video-category-image"
              ref={(el) => (combinedRef.current.image = el)}
              error={formDataError?.image}
            />

            <MessageLabel text={labelDisplay?.[12]?.title} className="" />
            <p className="mb-3 mt-0 theme-text-color opacity-75 admin-input-description">Select the image( 16:9 Ratio or 1280x720px )</p>
            <AdminImageUploadZone
              onChange={handleFileChange}
              selectedFile={bannerImageFile}
              uploadedImage={formData?.banner_image}
              onDelete={handleClearSelectFile}
              fileInputRef={setRef}
              name="banner_image"
              id={id}
              idAttribute="video-category-banner-image"
              ref={(el) => (combinedRef.current.image = el)}
              error={formDataError?.banner_image}
            />
          </Wrapper>

          <Wrapper>
            <MessageHeading text={labelDisplay?.[6]?.title} />
            <div className="d-flex justify-content-between mb-2 ">
              <div className="col-6 col-md-6 pe-2">
                <MessageLabel text={labelDisplay?.[7]?.title} className="" />
              </div>
              <div className="col-6 col-md-6 ps-2 text-end">
                <AdminSwitch id="video-category-in-home" name={"in_home"} checked={formData?.in_home == 1} onChange={handleInput} />
              </div>
            </div>
            <div className="d-flex justify-content-between mb-2 ">
              <div className="col-6 col-md-6 pe-2">
                <MessageLabel text={labelDisplay?.[8]?.title} className="" />
              </div>
              <div className="col-6 col-md-6 ps-2 text-end">
                <AdminSwitch id="video-category-in-menu" name={"in_menu"} checked={formData?.in_menu == 1} onChange={handleInput} />
              </div>
            </div>
            {/* <div className="d-flex justify-content-between mb-2 ">
              <div className="col-6 col-md-6 pe-2">
                <MessageLabel text={labelDisplay?.[9]?.title} className="" />
              </div>
              <div className="col-6 col-md-6 ps-2 text-end">
                <AdminSwitch id="video-category-banner" name={"banner"} checked={formData?.banner == 1} onChange={handleInput} />
              </div>
            </div> */}

          </Wrapper>

        </RightWrapper>
        <AdminCustomButton id="video-category-submit-down" className='px-3 py-1 m-0 ms-auto' saveMethod={handleStore} saveText={!id ? labelDisplay?.[13]?.title : labelDisplay?.[13]?.title} />
      </FormContainer>
    </div>
  );
}

export default AddManagevideocategories;